export default defineNuxtPlugin((nuxtApp) => {
  // ช่องทางหลัก: Cloudflare Workers AI (clef-flash + glm-5.3-flash) ผ่าน proxy ฝั่ง server
  const CLOUDFLARE_API_URL = '/api/ai/extract-invoice';
  // ช่องทางสำรองเดิม: APYHub ผ่าน gateway (บัญชีปัจจุบันหมดเครดิต)
  const APYHUB_API_URL = `https://gateway.cloudrestfulapi.com/ai?key=DU1eYMDG7j8yb199YDPg3`;

  const requestCloudflare = async (imageUrl, prompt) => {
    // proxy เป็น route ของ Nuxt เอง จึงต้องเรียกจากฝั่ง client เท่านั้น
    if (typeof window === 'undefined') {
      return { error: 'Cloudflare AI ใช้งานได้เฉพาะฝั่ง client' };
    }

    try {
      const response = await fetch(CLOUDFLARE_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ documentUrl: imageUrl, prompt }),
      });

      const data = await response.json();

      if (response.ok && data?.result) {
        return data.result;
      }

      const errorMessage = data?.error || `Cloudflare AI ไม่สำเร็จ (HTTP ${response.status})`;
      console.error('AI Plugin: Cloudflare AI error:', data);
      return { error: errorMessage };
    } catch (error) {
      console.error('AI Plugin: Cloudflare AI network error:', error);
      return { error: error?.message || 'ไม่สามารถเชื่อมต่อ Cloudflare AI ได้' };
    }
  };

  const requestApyhub = async (imageUrl, prompt) => {
    try {
      const response = await fetch(APYHUB_API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ documentUrl: imageUrl, prompt }),
      });

      const data = await response.json();

      if (response.ok && data?.result) {
        return data.result;
      }

      const errorMessage = data?.error || `ประมวลผลเอกสารไม่สำเร็จ (HTTP ${response.status})`;
      console.error('AI Plugin: APYHub error:', data);
      return { error: errorMessage };
    } catch (error) {
      console.error('AI Plugin: APYHub network error:', error);
      return { error: error?.message || 'ไม่สามารถเชื่อมต่อ APYHub ได้' };
    }
  };

  const processImageWithPrompt = async (imageUrl, prompt) => {
    const primaryResult = await requestCloudflare(imageUrl, prompt);
    if (primaryResult && !primaryResult.error) {
      return primaryResult;
    }

    console.warn('AI Plugin: Cloudflare AI failed, falling back to APYHub:', primaryResult?.error);
    const fallbackResult = await requestApyhub(imageUrl, prompt);
    if (fallbackResult && !fallbackResult.error) {
      return fallbackResult;
    }

    return { error: primaryResult?.error || fallbackResult?.error || "Sorry, I couldn't process the image." };
  };

  nuxtApp.provide("processImageWithPrompt", processImageWithPrompt);
});
